export default "__VITE_ASSET__BccSWawy__"